module.exports = new __parcel__URL__("Logo-Dark.9bf7eab9.svg").toString();